export const copyToClipboard = (value: string) =>
	window.navigator.clipboard.writeText(value);
